import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/services/user.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: 'app-items-received',
  templateUrl: './items-received.component.html',
  styleUrls: ['./items-received.component.css']
})
export class ItemsReceivedComponent implements OnInit {

  user: any;
  gcp: string;
  items: any[] = [];

  bookmark: string = "";
  totalCount: number = 0;
  pageSize: number = 5;
  page: any;

  columns: any[];
  bookmarks: any = [];

  subscriptions: any[] = [];

  constructor(
    private userService: UserService,
    private globalCfgService: GlobalCfgService,
  ) { }

  ngOnInit() {
    this.user = this.globalCfgService.getFullUserObj();

    this.loadItemsReceived()
  }

  loadItemsReceived(page?) {
    this.columns =[
      { name: "docType", displayName: "Type" },
      { name: "packageLevel", displayName: "Packaging Level" },
      { name: "packageType", displayName: "Packaging Type" },
      { name: "gcp", displayName: "Brand Owner" },
      { name: "instanceId", displayName: "Instance Id" },
      { name: "batchNo", displayName: "Batch" },
      { name: "mfgDate", displayName: "Batch Date", type: 'date', format: 'DD/MM/YYYY' },
      { name: "expiryDate", displayName: "Expiry Date", type: 'date', format: 'DD/MM/YYYY' },
      { name: "receivedDtm", displayName: "Received On", type: 'date', format: 'DD/MM/YYYY' }
    ];

    this.userService.itemsOwnedByUser(this.user["dappUserId"], page).subscribe(
      (response: any[]) => {
      this.items = response;
      console.log("items received: ", this.items);
      this.totalCount = this.items.length;
      }
    );
  }

  // onPageChanged(page) {
  //   this.pageSize = page.pageSize;
  //   this.loadItemsReceived(page);
  // }
}
